import './tabs.less'
export default {
    props: {
        data:{
            type: Array,
            default: () => []
        },
        value: {
            type: [String, Number],
            default: ''
        },
        valueIsRenderFlag: {
            type: Boolean,
            default: false
        },
        propsObj: {
            type: Object,
            default: () => {
                return {
                    value: {
                        value: 'value',
                        label: ''
                    },
                    label: {
                        value: 'label',
                        label: ''
                    },
                    count: {
                        value: 'value',
                        label: ''
                    }
                }
            }
        },
        countNum: {
            type: [String, Number],
            default: ''
        }
    },
    data() {
        return {

        }
    },
    methods: {
        selectMoney(item) {
            this.$emit('input', item[this.propsObj.value.value])
            this.$emit('update:countNum', item[this.propsObj.label.value])
        },
        valueIsRenderFun(item) {
            if(this.valueIsRenderFlag) {
               return  <p class="value">{item[this.propsObj.count.value]}{this.propsObj.count.label}</p>
            } 
            return ''
        }
    },
    render() {
        let { value, label } = this.propsObj
        return (
            <ul class="shortMessage-ul">
                {
                    this.data.map((item, index) => {
                        return (
                            <li key={index} onClick={this.selectMoney.bind(this,item)} class={{'active': item[value.value] === this.value}}>
                                <p class="label">{item[label.value]}{label.label}</p>
                                {
                                   this.valueIsRenderFun(item)
                                }
                            </li>
                        )
                    })
                }
            </ul>
        )
    }
}